/**
 * Formats milliseconds into a human-readable duration string.
 * Mirrors the backend formatDuration logic from PreLaunchAnalysisService.groovy
 *
 * @param {number} ms - Duration in milliseconds
 * @returns {string} Formatted duration (e.g., "2h 15m 30s", "45m 12s", "< 1s")
 *
 * @example
 * formatDuration(150000)  // "2m 30s"
 * formatDuration(3665000) // "1h 1m 5s"
 * formatDuration(500)     // "< 1s"
 */
function formatDuration(ms) {
  if (!ms || ms < 0) return '';
  if (ms < 1000) return '< 1s';

  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;

  const parts = [];

  if (h > 0) parts.push(`${h}h`);
  if (m > 0 || h > 0) parts.push(`${m}m`);
  parts.push(`${s}s`);

  return parts.join(' ');
}

export default formatDuration;
